/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '@environment/environment';

/**
 * Response interface for the new media upload API
 */
export interface MediaUploadResponse {
    data: {
        id: string;
        result_url: string;
    };
    meta: {
        code: number;
    };
}

@Injectable()
export class UnauthenService {
    private httpClient: HttpClient;

    constructor(private _httpBackEnd: HttpBackend) {
        this.httpClient = new HttpClient(this._httpBackEnd);
    }

    /**
     * Upload media file using the new CRM service-desk API
     * @param file - File to upload
     * @param token - Bearer token for authentication
     * @returns Observable with upload response containing id and result_url
     */
    public uploadMedia(file: File, token: string): Observable<MediaUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);

        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });

        return this.httpClient
            .post<MediaUploadResponse>(
                `${environment.domain.svf.uploadUrl}base-platform/crm/service-desk/v1/media/_upload`,
                formData,
                { headers }
            )
            .pipe(map((res: MediaUploadResponse) => res));
    }

    /**
     * @deprecated This method is deprecated and will be removed in future versions.
     * Use uploadMedia() instead.
     */
    public getSession(code: string): Observable<any> {
        return this.httpClient
            .post<any>(
                `${environment.domain.svf.uploadUrl}base-platform/mobile/sdk/v1/session`,
                { code }
            )
            .pipe(map((res: any) => res));
    }

    /**
     * @deprecated This method is deprecated and will be removed in future versions.
     * Use uploadMedia() instead.
     */
    public getAccessToken(codeVerifier, sessionId): Observable<any> {
        console.warn(
            'UnauthenService.getAccessToken() is deprecated. Use uploadMedia() instead.'
        );
        // Return empty observable as this method should no longer be used
        return new Observable((subscriber) => {
            subscriber.error(
                new Error('getAccessToken is deprecated. Use uploadMedia() instead.')
            );
        });
    }
}
